import { connection } from '@/api/connection'

export default {
  getContractCustomFieldValues: ({ contractId, productGroup }) => connection.get(`bo/contracts/${productGroup}/${contractId}/custom-fields/values`),
  postContractCustomFieldValues: ({ contractId, customFieldValues, productGroup }) => connection.post(
    `bo/contracts/${productGroup}/${contractId}/custom-fields/values`,
    customFieldValues.map(value => ({ ...value, contractId }))
  )
}
